import React, { useEffect } from 'react';
import emailjs from '@emailjs/browser';

const PaymentSuccess = () => {
  useEffect(() => {
    console.log("Preparing to send email...", process.env.REACT_APP_EMAIL_JS_SERVICE_ID);
    console.log("Template ID:", process.env.REACT_APP_EMAIL_JS_TEMPLATE_ID);


    emailjs.send(
      process.env.REACT_APP_EMAIL_JS_SERVICE_ID,
      process.env.REACT_APP_EMAIL_JS_TEMPLATE_ID,
    {},
      process.env.REACT_APP_EMAIL_JS_PUBLIC_key
    )
    .then(() => {
      console.log("מייל נשלח בהצלחה");
    })
    .catch((err) => {
      console.error("שגיאה בשליחת מייל:", err);
    });
  }, []);

  return (
    <div
      style={{
        minHeight: '70vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '24px'
      }}
    >
      {/* לוגו */}


      {/* כותרת ראשית */}
      <h1 style={{ fontSize: '3.2rem', marginBottom: 16 }}>
        (:מזל טוב על הרכישה 
      </h1>

      {/* טקסט משני */}
      <p style={{ fontSize: '1.5rem', marginBottom: 8 }}>
        איזה כיף לך – קנית בכזאתי מין תוכנית
      </p>
                  <p style={{ fontSize: '1.5rem', marginBottom: 3 }}>
        אנחנו בדרך למייל שלך
      </p>
            <p style={{ fontSize: '1.5rem', marginBottom: 12 }}>
!תפתחי כבר     </p>
      
      <img
        src="/לוגו שוכב.png"
        alt="Cazoty Min Tochnit"
        style={{ width: 500, marginBottom: 0, marginTop: 40 }}
      />
      {/* הודעת מייל */}
      <p style={{ fontSize: '1rem', color: '#555', marginTop: 60 }}>
        <br />
        
      </p>
    </div> );
};

export default PaymentSuccess;
